
<template>
  <div style="width:800px;height:400px;background-color:red;">

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>

@import '../assets/iconfont/iconfont.css'

</style>
